import { render, staticRenderFns } from "./diycoupon.vue?vue&type=template&id=307becd4&scoped=true&"
import script from "./diycoupon.vue?vue&type=script&lang=js&"
export * from "./diycoupon.vue?vue&type=script&lang=js&"
import style0 from "./diycoupon.vue?vue&type=style&index=0&id=307becd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307becd4",
  null
  
)

export default component.exports